<template>
  <el-container>
    <el-main class="main" :style="{ 'min-height': height, padding: 0 }">
      <div class="login" :style="{ minHeight: height }">
        <div class="login-header">
          <img class="fayou_logo" src="/images/login/shenbianhui-logo.png" />
        </div>
        <h1>区块链电子签署平台</h1>
        <el-card shadow="never" class="card" style="margin-top: 10px">
          <el-form
            :model="formData"
            size="small"
            label-position="right"
            :rules="rules"
            ref="form"
            class="form"
          >
            <el-form-item prop="username">
              <el-input
                v-model="formData.username"
                auto-complete="off"
                placeholder="用户名"
              >
                <i
                  @click="formData.username = ''"
                  slot="suffix"
                  class="el-input__icon el-icon-error"
                ></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                :type="viewPassword"
                v-model="formData.password"
                auto-complete="off"
                placeholder="密码"
              >
                <template slot="suffix">
                  <i
                    @click="viewPassword = 'text'"
                    v-if="viewPassword === 'password'"
                    class="el-input__icon icon icon-password-see"
                  ></i>
                  <i
                    @click="viewPassword = 'password'"
                    v-if="viewPassword === 'text'"
                    class="el-input__icon icon icon-password-nosee"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
            <template v-if="imgAuth.show">
              <el-form-item prop="imgAuth">
                <el-input
                  v-model="formData.imgAuth"
                  auto-complete="off"
                  placeholder="验证码"
                >
                  <template slot="append">
                    <div @click="getImgAuth" class="img-code">
                      <img :src="'data:image/jpeg;base64,' + imgAuth.imgPath" />
                    </div>
                  </template>
                </el-input>
              </el-form-item>
            </template>

            <el-form-item>
              <el-button
                @click.prevent="submit"
                type="danger"
                style="width: 100%"
                >立即登录</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-row class="text-center">
                <el-col :span="12">
                  <nuxt-link
                    :to="{
                      path: '/account/register-shenbianhui',
                      query: { si: '24C7CFC39B4D74321AB3C4EEDB66CAE2' },
                    }"
                    >新用户注册</nuxt-link
                  >
                </el-col>
                <el-col :span="12">
                  <nuxt-link
                    :to="{
                      path: '/account/forgetPwd',
                      query: { tag: 'mobile' },
                    }"
                    target="_blank"
                    >忘记密码</nuxt-link
                  >
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </el-main>
    <el-footer height="40px">区块链100强企业，国家专利产品</el-footer>
  </el-container>
</template>

<script>
import { postLogin, postImgCode, profile, ApiMethods } from '../../assets/js/http-serve/http-methods';
import { password, imgAuth, username } from '../../assets/js/lib/valid-methods';
import GlobalConfig from '@/assets/js/config/global';
import {
  loginOrRefresh
} from '../../assets/js/http-serve/corp/common';
import md5 from 'js-md5';
import sha512 from 'js-sha512';
import { isInDingTalk } from "@/assets/js/utils/ding-env";

let base64 = require('js-base64').Base64;

export default {
  head () {
    return {
      title: '',
    };
  },
  methods: {
    gotoPrm () {
      const url = 'http://prm.junziqian.com/login.html';
      isInDingTalk ? location.href = url : window.open(url, '_blank');
    },
    submit: function () {
      var _this = this;
      _this.$refs.form.validate(val => {
        if (val || val === 'true') {
          let loading = _this.$loading({
            lock: true,
            text: '正在登录',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, .5)',
          });

          if (_this.formData.imgAuth) {
            _this.formData.imgCode = `${_this.imgAuth.imgToken}_${_this.formData.imgAuth}`;
          }

          var param = {
            account: _this.formData.username,
            password: sha512(
              _this.formData.username + md5(_this.formData.password)),
            tokenValiCode: _this.formData.imgCode,
          };
          ApiMethods.AccountLoginController.ssoLogin(param).then(async result => {
            loading.close();
            if (result.success) {
              var s = result.data.s;
              var t = result.data.t;
              var ap = encodeURIComponent(_this.$route.query.ap || "/viewIndex");
              var cp = encodeURIComponent(GlobalConfig.domain.junziqianWebOp + "/login/authorize");
              let signUrl = localStorage.getItem('sign-url');
              if (signUrl) {
                ap = encodeURIComponent(signUrl);
                localStorage.removeItem('sign-url');
              }
              window.location.href = GlobalConfig.domain.accountWeb + "/login/authentication?ap=" + ap + "&cp=" + cp + "&t=" + t + "&s=" + s;
            } else if (result.code == 60101003) {
              _this.$message.error('请输入正确的验证码');
              _this.formData.imgAuth = '';
              _this.getImgAuth();
            } else if (result.code == 60102201) {
              _this.$message.error(result.message || '账户名或密码不正确');
              _this.formData.password = '';
              _this.$refs.passwordInput.$el.querySelector('input').focus();
              _this.formData.imgAuth = '';
              _this.getImgAuth();
            } else {
              _this.$message.error(result.message || '登录失败');
              _this.formData.password = '';
              _this.$refs.passwordInput.$el.querySelector('input').focus();
              if (_this.imgAuth.show) {
                _this.formData.imgAuth = '';
                _this.getImgAuth();
              }
            }
          }).catch(error => {
            loading.close();
          });

        }
      });
    },
    getImgAuth: function () {
      postImgCode(1)
        .then(({ data }) => {
          this.imgAuth = data;
          this.imgAuth.show = true;
        });
    },
  },
  data () {
    return {
      formData: { username: '', password: '', imgCode: null, imgAuth: '' },
      rules: {
        username: [{ validator: username, trigger: 'blur' }],
        password: [{ validator: password, trigger: 'blur' }],
        ingAuth: [{ validator: imgAuth, trigger: 'blur' }],
      },
      imgAuth: { imgToken: null, imgPath: null, show: false },
      viewPassword: 'password',
      height: '877px',
    };
  },
  mounted () {
    this.height = (document.body.clientHeight || window.document.body.clientHeight) - 40 + 'px';
    window.localStorage.setItem('login-path', this.$route.path);
  },
  created () { },
  layout: 'empty',
  name: 'index',
};
</script>

<style>
.el-input-group__append {
  background-color: #c0c4cc !important;
  border-color: #c0c4cc !important;
}
</style>
<style lang="less" scoped>
.login .card .nav-bar ul li.active[data-v-37c64fb3] {
  color: #019fe8;
}

.el-button--danger,
.el-badge__content {
  background-color: #019fe8;
  border-color: #019fe8;
}

.login {
  width: 100%;
  min-height: 108%;
  background: url("../../static/images/login/fayou-bg.png") no-repeat;
  background-size: cover;
  overflow: hidden;

  .login-header {
    width: 100%;
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
    background-color: #040e51;

    .fayou_logo {
      width: auto;
      height: 80%;
      margin-left: 20px;
      display: inline-block;
      vertical-align: middle;
    }
  }

  h1 {
    display: block;
    width: 288px;
    font-size: 32px;
    color: #ffffff;
    line-height: 47px;
    margin: 280px auto 30px;
    font-weight: 400;
  }

  .card {
    box-sizing: border-box;
    max-width: 540px;
    margin: 60px auto 0;
    padding: 40px 110px;
    background: #eee;

    .form {
      .img-code {
        background-color: white;
        display: inline-block;
        margin: 0 -20px;
        width: 100px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;

        img {
          vertical-align: middle;
          display: inline-block;
          height: 27px;
          width: 100%;
        }
      }
    }

    .nav-bar {
      width: 100%;
      overflow: hidden;
      margin-bottom: 30px;

      ul {
        width: 100%;

        li {
          width: 33%;
          height: 27px;
          line-height: 27px;
          font-size: 16px;
          font-weight: 600;
          color: #1b1b1b;
          border-bottom: 1px solid #bfbfbf;
          margin-bottom: -1px;

          span {
            display: block;
            cursor: pointer;
          }
        }

        li.active {
          font-size: 15px;
          color: #ec1c1c;
          border-bottom-color: #ec1c1c;
        }
      }
    }

    .login-logo {
      margin: 10px 0 30px 0;

      img {
        max-width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/login-shenbianhui/index.vue